
import { ref, onMounted } from 'vue';
import ModalMessage from '@/components/ModalMessage.vue';
import { Modal } from '@/interfaces/Modal';

export default {
  components: {
    ModalMessage,
  },
  setup() {
    const gebruikersnaam = ref<string>('');
    const password = ref<string>('');
    const confirmpassword = ref<string>('');
    const resetToken = ref<string>('');
    const isValidToken = ref<boolean>(false);
    const modal = ref<Modal>({ show: false, title: 'Wachtwoord wijzigen', msg: '' });
    const isSuccess = ref<boolean>(false);

    onMounted(async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const user = urlParams.get('user') || '';
      const token = urlParams.get('resetToken') || '';

      if (user && token) {
        try {
          const response = await fetch('/umbraco/api/member/postvalidateresettoken', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userName: user, resetToken: token }),
          });

          if (response.ok) {
            gebruikersnaam.value = user;
            resetToken.value = token;
            isValidToken.value = true;
          } else {
            isValidToken.value = false;
          }
        } catch (error) {
          isValidToken.value = false;
        }
      } else {
        isValidToken.value = false;
      }
    });

    const submitForm = async () => {
      try {
        const response = await fetch('/umbraco/api/member/postpasswordreset', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userName: gebruikersnaam.value,
            password: password.value,
            confirmPassword: confirmpassword.value,
            resetToken: resetToken.value,
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (response.status === 400) {
            const { errors } = errorData;
            modal.value.msg = Object.values(errors).flat().join('<br>');
          } else {
            modal.value.msg = 'Er is iets misgegaan neem svp contact op met de klantenservice.';
          }
          modal.value.show = true;
          return;
        }

        modal.value.msg = 'Je wachtwoord is succesvol gewijzigd. Je kunt nu inloggen met je nieuwe wachtwoord.';
        modal.value.show = true;
        isSuccess.value = true;

        setTimeout(() => {
          window.location.href = '/';
        }, 10000);
      } catch (error) {
        modal.value.msg = 'Er is iets misgegaan neem svp contact op met de klantenservice.';
        modal.value.show = true;
      }
    };

    const handleModalClose = () => {
      modal.value.show = false;
      if (isSuccess.value) {
        window.location.href = '/';
      }
    };

    return {
      gebruikersnaam,
      password,
      confirmpassword,
      resetToken,
      isValidToken,
      modal,
      submitForm,
      handleModalClose,
    };
  },
};
